export function useRelativeTime() {
  return {relativeTimeFormat}
}

function relativeTimeFormat(date: string | Date): string {
  const parsedDate = date instanceof Date ? date : new Date(date)
  if (Number.isNaN(parsedDate.getTime())) return 'Invalid date'

  const now = new Date()
  const seconds = Math.floor((now.getTime() - parsedDate.getTime()) / 1000)

  const intervals: {[key: string]: number} = {
    year: 31536000,
    month: 2592000,
    week: 604800,
    day: 86400,
    hour: 3600,
    minute: 60,
  }

  for (const [unit, secondsInUnit] of Object.entries(intervals)) {
    const interval = Math.floor(seconds / secondsInUnit)
    if (interval >= 1) {
      return interval === 1 ? `a ${unit} ago` : `${interval} ${unit}s ago`
    }
  }

  return 'just now'
}
